import React from "react";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {StyledRadio} from "../../../../utils/designComponents/StyledRadio";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

export default function DataSourceDropDown({dataSource, setDataSource, setBrokerage, setAccountNumber}) {
    const values =
        {
            "LIVE": {
                setter: value => {
                    setDataSource(value);
                    setBrokerage('');
                    setAccountNumber('');
                }
            },
            "SIMULATED": {
                setter: (value) => {
                    setDataSource(value);
                    setBrokerage('BACKTEST');
                    setAccountNumber('BACKTEST');
                }
            }
        };


    return (
        <TextField
            aria-label="dataSource"
            name="dataSource"
            variant="outlined"
            size="small"
            style={{backgroundColor: "white", width: "100%"}}
            select
            value={dataSource}
            onChange={(ev) => {
                values[ev.target.value].setter(ev.target.value);
            }}
            label={<Typography style={{fontSize: 10}}>DataSource</Typography>}
        >
            {Object.keys(values).map((option) => (
                <MenuItem key={option} value={option}>
                    <Typography style={{fontSize: 9}}>{option}</Typography>
                </MenuItem>
            ))}
        </TextField>
    )
        ;
}
